import React, { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Textarea,
  Button,
  Image,
  Spinner,
} from '@nextui-org/react';
import InputModal from '../Modal/InputModal';
import { message } from 'antd';
import { submitPost } from '../../services/querys ';
import { postValidate } from '../../utils/Validation/postConstraint';
import { useSelector } from 'react-redux';
import { decryptData } from '../../utils/encryptData';

function PostAddSection({ id }) {
  const [image, setImage] = useState(null);
  const [description, setDescription] = useState('');

  const handelFileChange = (image) => {
    setImage(image);
  };

  const { uid, rl } = useSelector((state) => state.auth);
  const loggedInUserId = decryptData(uid);
  const role = decryptData(rl);

  const queryClient = useQueryClient();

  //submit post - 2
  const { mutate: addPostMutation, isPending } = useMutation({
    mutationFn: submitPost,
    onError: (error) => {
      console.error('Error adding post:', error);
      message.error(error.message);
    },
    onSuccess: async () => {
      message.success('Post added successfully');
      await queryClient.invalidateQueries(['posts']);
      setImage(null);
      setDescription('');
    },
  });

  //submit post - 1
  const handleSubmitPost = async () => {
    if (role !== 'admin' && role !== 'user' && role !== 'editor') {
      message.error('Please create an account.');
      return;
    }

    const errors = await postValidate({ description: description });

    if (Object.keys(errors).length > 0) {
      message.error(errors.description);
      return;
    }

    const formData = new FormData();

    formData.append('files', image);
    formData.append('description', description);

    if (id) {
      formData.append('topicId', id);
      formData.append('status', false);
    }

    addPostMutation(formData);
  };

  return (
    <>
      <Card className="bg-background-secondary-color  font-poppins mb-4">
        <CardHeader className="text-white">
          <h2 className="md:text-2xl text-gray-200 font-bold font-poppins text-xl">
            Share your ideas
          </h2>
        </CardHeader>

        <CardBody>
          <Textarea
            onChange={(e) => setDescription(e.target.value)}
            value={description}
            maxLength={3000}
            minLength={1}
            placeholder="How do you feel about the market today? Share your ideas here!"
            className="max-w-full text-h6 font-poppins col-span-4 text-sm"
          />
        </CardBody>

        {image && (
          <Image
            radius="lg"
            alt="NextUI hero Image"
            src={URL.createObjectURL(image)}
            loading="lazy"
            className="w-full px-3 max-h-96"
          />
        )}

        <CardFooter className="justify-between items-center">
          <InputModal onChange={handelFileChange} />

          <Button
            isLoading={isPending}
            onClick={handleSubmitPost}
            className="border-btn-color font-poppins text-white text-xs md:text-sm"
            variant="bordered"
            size="sm"
          >
            Post
          </Button>
        </CardFooter>
      </Card>
    </>
  );
}

export default PostAddSection;
